import AssetComponentWidget from "./components/AssetComponentWidget.vue";
import assetComponentStore from "./store/assetComponentStore";
import PaymentWidget from "./components/PaymentWidget";
import CurrencyRateParametersWidget from "./components/CurrencyRateParametersWidget";
import IndexationParametersWidget from "./components/IndexationParametersWidget";
import DiscountParametersWidget from "./components/DiscountParametersWidget";
import AssetComponentWithoutStore from "./components/AssetComponentWithoutStore";

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    options.store.registerModule('assetComponentsPlugin', assetComponentStore);

    Vue.component('AssetComponentWidget', AssetComponentWidget);
    Vue.component('AssetComponentWithoutStore', AssetComponentWithoutStore);
    Vue.component('PaymentWidget', PaymentWidget);
    Vue.component('CurrencyRateParametersWidget', CurrencyRateParametersWidget);
    Vue.component('IndexationParametersWidget', IndexationParametersWidget);
    Vue.component('DiscountParametersWidget', DiscountParametersWidget);
  },
};
